import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from '../../core/service/message.service';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { DataService } from '../../core/service/base/data.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Meter } from '../model/meter';

@Injectable()
export class MeterService extends DataService<Meter> {
  getPropertyMeters(propertyId: string): Observable<Meter[]> {
    return this.client.get<Meter[]>(`${this.endpoint}/property/${propertyId}`).pipe(map(res => res.map(t => this.createModel(t))));
  }

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, Meter, progressBar, 'imd-meter');
  }
}
